import axiosOther from "@/libs/http/axios-others.js";
// import axios from 'axios'
import url from './server-config'
import utils from "@/libs/utils/utils";
import jsBridge from '@/libs/jsBridge'



// console.log(utils)
// if(!utils.getToken()){
//     jsBridge.showLoginView()
// }
const service = {}
const confHeader = {
    headers: {
        'Content-Type': 'application/json',
        // 'token':"443d58139d0d6b1be9571f595640dec7" // 陈浩
        // 'token':"670deddebff96a00ce59763ae42063ce" // 自己
        'token': utils.getToken()
    }
}

service.get = (url,params,conf) => {
    return new Promise(((resolve, reject) => {
        axiosOther.get(url,{params,...conf,...confHeader}).then(r => {
            if(r.data.code == 401 || r.data.code == 1151){
                console.warn(r.data.message)
                jsBridge.showLoginView()
                reject(r.data)
            } else {
                resolve(r.data)
            }
        }).catch(e => reject(e))
    }))
}
service.post = (url,data,conf) => {
    return new Promise(((resolve, reject) => {
        axiosOther.post(
            url,
            data,
            {
                ...conf,
                ...confHeader,
                transformRequest: [(data) => {
                    data = JSON.stringify(data)
                    return data
                }],
            }).then(r => {
                if(r.data.code == 401 || r.data.code == 1151){
                    console.warn(r.data.message)
                    jsBridge.showLoginView()
                    reject(r.data)
                } else {
                    resolve(r.data)
                }
        }).catch(e => reject(e))
    }))
}
// 获取图片oss密钥
export const genSts = params => service.get(`${url}/fileUpload/uploadKey`, params)

// 获取品牌列表
export const getBrandList = params => service.post(`${url}/carSale/getBrandList`, params)
// 获取车型分组列表
export const getCarTypeList = params => service.post(`${url}/carSale/getCarTypeList`, params)
// 获取售卖车辆列表
export const getCarList = params => service.post(`${url}/carSale/getListByCondition`, params)

// 获取车辆详情
export const getCarDetail = params => service.get(`${url}/carSale/getCarDetail`, params)



/* 订单 */
// 获取售卖订单列表
export const getOrderList = params => service.post(`${url}/saleOrder/getSaleOrderList`, params)
// 获取订单详情
export const getOrderDetail = params => service.post(`${url}/saleOrder/getSaleOrderDetail`, params)

/* 预定 */
// 预定生成订单
export const createOrder = params => service.post(`${url}/saleOrder/createOrder`, params)

// 拉取支付类型列表
export const getPayTypeList = params => service.post(`${url}/coupon/payTypeList`, params)

// 支付
export const goPay_api = params => service.post(`${url}/coupon/sponsorPay`, params)


// 我的权益
export const getMyOrderEquitieList = params => service.post(`${url}/saleOrder/getMyOrderEquitieList`, params)

// 兑换码
export const exchangeRedeemCode = params => service.post(`${url}/coupon/exchangeRedeemCode`, params)
// 兑换码列表
export const getCouponList = params => service.post(`${url}/coupon/couponList`, {...params,pageNum:1,pageSize:20})

// 获取优惠卷详情
export const getCouponDetail = params => service.post(`${url}/coupon/couponDetail`, params)


// 获取协议内容
export const getTemplatesByBusinessIdLists = params => service.post(`${url}/contractTemplate/getTemplatesByBusinessIdLists`, params)



// WEBPACK FOOTER //
// src/pages/saleCar/api.js